import DatePicker from "./DatePicker";
import { CalendarRange } from "lucide-react";

export default function DateRange({ from, to, onFrom, onTo, onClear }) {
  return (
    <div data-testid="date-range" className="flex items-center gap-2 flex-wrap bg-white border border-stone-200 rounded-sm px-3 py-2">
      <CalendarRange size={16} className="text-brand" strokeWidth={1.5} />
      <span className="text-xs uppercase tracking-[0.12em] font-bold text-stone-500">Periodo</span>
      <DatePicker value={from} onChange={onFrom} testid="date-from" placeholder="Da" />
      <span className="text-stone-400 text-sm">→</span>
      <DatePicker value={to} onChange={onTo} testid="date-to" placeholder="A" />
      {(from || to) && (
        <button data-testid="date-clear" onClick={onClear} className="text-xs text-brand hover:underline ml-1">Azzera</button>
      )}
    </div>
  );
}

export function rangeParams(from, to) {
  const p = {};
  if (from) p.dfrom = from;
  if (to) p.dto = to;
  return p;
}
